import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectDecorationsList = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('decorations_list')(jsonQuery),
);
